import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const LabelCard = styled.div`
  padding-bottom: 20px;
`

export const Value = styled.span`
  color: ${colors.grayDark};
  font-size: 12px;
  font-weight: 700;
`
export const Title = styled.span`
  color: ${colors.blue};
  font-size: 12px;
`
